/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Type_PhraseInputs */

const en_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const fr_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const de_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrase`)
};

const it_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frase`)
};

const ru_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фраза`)
};

const es_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frase`)
};

const zh_cn2_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短语`)
};

const ja_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーズ`)
};

const hi_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वाक्यांश`)
};

const pt_pt2_tags_manager_type_phrase = /** @type {(inputs: Tags_Manager_Type_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frase`)
};

/**
* | output |
* | --- |
* | "Phrase" |
*
* @param {Tags_Manager_Type_PhraseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_type_phrase = /** @type {((inputs?: Tags_Manager_Type_PhraseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Type_PhraseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_type_phrase(inputs)
	if (locale === "de") return de_tags_manager_type_phrase(inputs)
	if (locale === "it") return it_tags_manager_type_phrase(inputs)
	if (locale === "ru") return ru_tags_manager_type_phrase(inputs)
	if (locale === "es") return es_tags_manager_type_phrase(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_type_phrase(inputs)
	if (locale === "ja") return ja_tags_manager_type_phrase(inputs)
	if (locale === "hi") return hi_tags_manager_type_phrase(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_type_phrase(inputs)
	return en_tags_manager_type_phrase(inputs)
});